import { isStore } from 'utils/location'
import { useEssentials } from 'hooks/utils/useEssentials'
import { PayrollStore } from './payroll'
import { PayrollRGD } from './payroll-rgd'

export const AssetsProtectionPayroll = () => {
    const { currentLocation } = useEssentials()

    return isStore(currentLocation) ? <PayrollStore /> : <PayrollRGD />
}
